module.exports = __webpack_public_path__ + "img/id-card.c45862e4.svg";